import CoverageTable from './CoverageTable';

export default CoverageTable;
